import { dataHooks as createDataHooks } from '@wix/data-hooks'

export const dataHooks = createDataHooks<{
  title: {}
  subtitle: {}
  image: { index: number }
}>('wix-studio-mobile-stores')
